<div class="write-review">

    <div class="top-head">
      <h3>Write a Review</h3>
      <img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/close.svg'" (click)="onNoClick(false)" class="close" alt="Close | Luminous">
    </div>
    <div class="review-row">
      <div>
        <form (ngSubmit)="onSubmit()" [formGroup]="reviewForm" class="row">
          <div class="col-md-6">
            <div class="review-col">
              <h4>Rate the following aspects of the product</h4>
              <div *ngFor="let attribute of data.reviews">
                <div class="main">
                  <p>{{attribute.name? attribute.name: attribute.reviewName}}</p>
                  <ul>
                    <li role="button" *ngFor="let key of [1, 2, 3, 4, 5]"
                      [ngClass]="{'active': reviewForm.controls[attribute.reviewSubGuidId].value == key}"
                      (click)="setRatingValue(attribute.reviewSubGuidId, key)">{{key}}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="review-col">
              <h5>What do you think of this product?</h5>
              <div class="cst-form-group">
                <input type="text" formControlName="title" class="cst-form-control" placeholder="Title">
                <div class="errorIconContainer" *ngIf="utils.checkValidation('title',reviewForm)">
                  <img class="errorImg"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/error.svg'" alt="Error | Luminous">
                </div>
                <div class="errorDescription" *ngIf="utils.checkValidation('title',reviewForm)">
                  {{utils.checkValidationMessage(reviewForm,'title','Title')}}
                </div>
              </div>
              <div class="cst-form-group">
                <textarea formControlName="description" cols="30" rows="10"
                  placeholder="What do you think of this product?"
                  class="cst-form-control">What do you think of this product?</textarea>
                <div class="errorIconContainer" *ngIf="utils.checkValidation('description',reviewForm)">
                  <img class="errorImg"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/error.svg'" alt="Error | Luminous">
                </div>
                <div class="errorDescription" *ngIf="utils.checkValidation('description',reviewForm)">
                  {{utils.checkValidationMessage(reviewForm,'description','Description')}}
                </div>
              </div>
              <div class="cst-form-group text-center">
                <input type="button" [disabled]="!reviewForm.valid" (click)="onSubmit()" value="Submit Review" class="primaryBtn">
              </div>
            </div>
          </div>
        </form>
      </div>
  
  
    </div>
  
  </div>
  